import { Controller } from "@hotwired/stimulus"

// "Customers on this list": search to add, chip to remove. When a customer is
// already pinned to a DIFFERENT list, the chip warns and requires an explicit
// Override toggle before it will move them — the hidden customer_ids input is
// only emitted when the customer is actually included. A separate always-blank
// input (in the view) lets "no customers" submit and clear the list.
export default class extends Controller {
  static targets = ["search", "results", "chips"]
  static values = { customers: Array }

  connect() {
    this.selected = new Map() // id -> { name, listName, override }
    this.customersValue
      .filter((c) => c.pinnedHere)
      .forEach((c) => this.selected.set(c.id, this.entry(c, true)))
    this.renderChips()
    this.onAway = (e) => { if (!this.element.contains(e.target)) this.hideResults() }
    document.addEventListener("click", this.onAway)
  }

  disconnect() { document.removeEventListener("click", this.onAway) }

  entry(c, included) {
    return { name: c.name, listName: c.listName, override: included }
  }

  filter() {
    const q = this.searchTarget.value.trim().toLowerCase()
    const matches = this.customersValue
      .filter((c) => !this.selected.has(c.id))
      .filter((c) => q === "" || c.name.toLowerCase().includes(q))
      .slice(0, 8)
    this.resultsTarget.innerHTML = matches
      .map(
        (c) =>
          `<button type="button" class="pl-cust-option" data-action="customer-pinning#add" data-id="${c.id}">` +
          `<span>${this.esc(c.name)}</span>` +
          (c.listName ? `<span class="pl-cust-on">on ${this.esc(c.listName)}</span>` : "") +
          `</button>`
      )
      .join("")
    this.resultsTarget.hidden = matches.length === 0
  }

  add(event) {
    const id = event.currentTarget.dataset.id
    const c = this.customersValue.find((x) => x.id === id)
    if (!c) return
    // No list -> include immediately; already on another list -> needs Override.
    this.selected.set(id, this.entry(c, !c.listName))
    this.searchTarget.value = ""
    this.hideResults()
    this.renderChips()
    this.searchTarget.focus()
  }

  remove(event) {
    this.selected.delete(event.currentTarget.dataset.id)
    this.renderChips()
  }

  toggleOverride(event) {
    const e = this.selected.get(event.currentTarget.dataset.id)
    if (e) {
      e.override = event.currentTarget.checked
      this.renderChips()
    }
  }

  renderChips() {
    const rows = []
    this.selected.forEach((e, id) => {
      const warn = e.listName && !e.override
      rows.push(
        `<div class="pl-cust-chip${warn ? " is-warn" : ""}">` +
          (e.override ? `<input type="hidden" name="price_list[customer_ids][]" value="${id}">` : "") +
          `<span class="pl-cust-chip-name">${this.esc(e.name)}</span>` +
          (e.listName
            ? `<label class="pl-cust-override"><input type="checkbox" data-action="customer-pinning#toggleOverride" data-id="${id}"${
                e.override ? " checked" : ""
              }> override “${this.esc(e.listName)}”</label>`
            : "") +
          `<button type="button" class="pl-cust-x" data-action="customer-pinning#remove" data-id="${id}" aria-label="Remove ${this.esc(e.name)}">×</button>` +
          `</div>`
      )
    })
    this.chipsTarget.innerHTML =
      rows.join("") || `<p class="pl-muted">No customers pinned yet — search above to add one.</p>`
  }

  hideResults() { this.resultsTarget.hidden = true }

  esc(s) {
    const d = document.createElement("div")
    d.textContent = s == null ? "" : s
    return d.innerHTML
  }
}
